import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
  Box,
  Paper,
  Typography,
  Button,
  Modal,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

const TextEditorModal = ({ handleCloseModal, showModal, onCopyPath }) => {
  const [imageData, setImageData] = useState([]);
  const [currentPages, setCurrentPages] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [selectedImage, setSelectedImage] = useState({ isHome: false });

  useEffect(() => {
    getData();
  }, [currentPages]);

  const getData = () => {
    axios
      .get("/api/v1/images", {
        params: {
          page: currentPages,
          limit: 20,
        },
      })
      .then((res) => {
        setImageData(res.data.images);
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => console.log(err));
  };

  const goToPage = (page) => {
    setCurrentPages(page);
  };

  const handleCopyPath = (value) => {
    navigator.clipboard.writeText(value).then(() => {
      if (onCopyPath) {
        onCopyPath(value);
      } else {
        toast("Đã copy đường dẫn hình ảnh", {
          type: "success",
          autoClose: 2500,
        });
      }
    });
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (isReload) => {
    setOpen(!open);
    setImage(null);
    setPreview(null);
    setChecked(false);
    if (isReload) {
      getData();
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const sendData = {
      path: image,
      isHome: checked,
    };
    axios
      .post(`/api/v1/images`, sendData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        toast("Thêm hình ảnh thành công!", {
          type: "success",
          autoClose: 1000,
        });
        handleClose(true);
      })
      .catch((err) => {
        console.log(err);
        toast("Có lỗi xảy ra!", {
          type: "error",
          autoClose: 1000,
        });
      });
  };

  return (
    <>
      <Modal
        open={showModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              width: 1000,
              height: "95vh",
              p: 4,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Typography variant="h4" gutterBottom>
              Danh sách hình ảnh
            </Typography>
            <Box sx={{ pb: 2 }}>
              <Button variant="contained" color="primary" onClick={handleOpen}>
                Thêm hình ảnh
              </Button>
            </Box>
            <Paper
              sx={{
                height: 550,
                width: "100%",
                display: "grid",
                gap: 2,
                p: 2,
                gridTemplateColumns: "repeat(4, 1fr)",
                gridAutoRows: 150,
                mb: 2,
                overflowY: "auto",
              }}
            >
              {imageData.map((item, idx) => (
                <Box
                  component="img"
                  key={idx}
                  onClick={() => handleCopyPath(item.path)}
                  sx={{
                    width: 200,
                    height: 150,
                    objectFit: "cover",
                    borderRadius: "8px",
                    mb: 2,
                    cursor: "pointer",
                  }}
                  alt={item.path}
                  src={item.path}
                />
              ))}
            </Paper>
            <Box>
              <div className="pagination" style={{ margin: "15px 0" }}>
                <button
                  className={`page-button ${currentPages == 1 ? "active" : ""}`}
                  id="prev-btn"
                  disabled={currentPages == 1}
                  onClick={() => goToPage(currentPages - 1)}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <span className="page-numbers">
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      className={`page-number ${
                        index + 1 === currentPages ? "active" : ""
                      }`}
                      onClick={() => goToPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </span>
                <button
                  className={`page-button ${
                    currentPages == totalPages ? "active" : ""
                  }`}
                  id="next-btn"
                  disabled={currentPages == totalPages}
                  onClick={() => goToPage(currentPages + 1)}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCloseModal}
              >
                Đóng
              </Button>
            </Box>
          </Paper>
        </Box>
      </Modal>

      {/* add image */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              width: 600,
              p: 5,
              maxHeight: "95vh",
              overflowX: "hidden",
              overflowY: "auto",
            }}
          >
            <Typography sx={{ pb: 5 }} variant="h4" component="h2">
              Thêm hình ảnh
            </Typography>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 2, pb: 5 }}
            >
              <Button variant="outlined" component="label">
                Tải ảnh lên
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleImageChange}
                />
              </Button>
              <Box sx={{ color: "red", fontSize: 14 }}>
                (*) Nếu hiển thị trang chủ khuyến kích chọn hình ảnh có kích
                thước 500 x 600
              </Box>
              {image && (
                <TextField
                  label="Tên tệp"
                  value={image.name}
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
              )}
              {preview && (
                <Box sx={{ marginTop: 2 }}>
                  <Typography variant="body1">Xem trước:</Typography>
                  <Box
                    component="img"
                    sx={{
                      width: 200,
                      height: 300,
                      objectFit: "cover",
                      borderRadius: "8px",
                      mb: 2,
                    }}
                    alt={preview}
                    src={preview}
                  />
                </Box>
              )}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                  />
                }
                label="Hiển thị trang chủ"
              />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "end", gap: 3 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
              >
                Trở về
              </Button>
              <Button variant="contained" color="info" onClick={handleSubmit}>
                Lưu
              </Button>
            </Box>
          </Paper>
        </Box>
      </Modal>
    </>
  );
};

export default TextEditorModal;
